import { createSelectorCreator, lruMemoize } from 'reselect';
import { isEqual } from 'lodash/fp';

const createDeepEqualSelector = createSelectorCreator(lruMemoize, isEqual);

export default createDeepEqualSelector;
